export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40cd9cbaccda1f14bfa26f8404a9b22df55c166131&name=addToFolderEventAction!'